<script>
  export let idUnico = 'podcast';
  import Button from '../ui/button.svelte';
  import IoIosClose from 'svelte-icons/io/IoIosClose.svelte';
  export let arquivoMP3 = '';
  import navegacaoStore from '../../store';
  import { onMount } from 'svelte';
  export let content;
  let ativo = false;
  function abrir() {
    ativo = true;
  }

  console.log(idUnico);

  let podId = [];
  podId = idUnico.split('-');

  let comandoBegin;
  let comandoEnd;
  let comandoFrase;

  onMount(() => {
    let dados;

    navegacaoStore.subscribe((dadosStore) => {
      dados = dadosStore;
    });

    arquivoMP3 =
      dados.podcastPath +
      'senappen_podcast_c4_m' +
      dados.modulo +
      '_u' +
      podId[1] +
      '_' +
      podId[2] +
      '.mp3';

    comandoBegin = content.search('<comando>');
    if (comandoBegin != -1) {
      comandoEnd = content.search('</comando>');
      if (comandoEnd != -1) {
        comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
        content = content.substring(comandoEnd + 10, content.length);
      }
    }
  });
</script>

<div class="container" id={idUnico}>
  <p class="comando">
    {@html comandoFrase}
  </p>
  <div class="wrapper">
    <div class="title">
      <h3><i>PODCAST</i></h3>
    </div>
    <div class="caixa">
      <div class="ilustra">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="99"
          height="66"
          viewBox="0 0 91 68"
          fill="none"
        >
          <path
            d="M18.2374 65.5498V35.5955H22.7874C24.2727 35.5955 25.4572 36.7237 25.4572 38.1152V63.0301C25.4572 64.4216 24.2539 65.5498 22.7874 65.5498H18.2374Z"
            fill="url(#paint0_linear_509_528)"
          />
          <path
            d="M22.7874 36.6297C23.6898 36.6297 24.4231 37.2878 24.4231 38.1152V63.0302C24.4231 63.8575 23.6898 64.5157 22.7874 64.5157H19.2715V36.6297H22.7874ZM22.7874 34.5613H17.2033V66.5841H22.7874C24.8367 66.5841 26.4913 64.9858 26.4913 63.0302V38.1152C26.4913 36.1596 24.8179 34.5613 22.7874 34.5613Z"
            fill="white"
          />
          <path
            d="M73.4197 65.5499V36.7049C72.1788 21.5303 59.8827 9.64632 45.4056 9.64632C30.9284 9.64632 18.6323 21.5303 17.3914 36.7049V65.5311H8.79909C5.37722 65.5311 2.57581 62.955 2.57581 59.7959V41.3118C2.57581 38.1528 5.35842 35.5767 8.79909 35.5767H9.08111C10.9049 16.6037 26.6793 1.88037 45.4244 1.88037C64.1694 1.88037 79.9251 16.6225 81.73 35.5955H82.0308C83.7606 35.5955 85.4339 36.2724 86.6184 37.4383C87.6713 38.4913 88.2541 39.8828 88.2541 41.3118V59.8147C88.2541 62.9738 85.4715 65.5499 82.0308 65.5499H73.4386H73.4197Z"
            fill="url(#paint1_linear_509_528)"
          />
          <path
            d="M45.4243 2.9146C64.1318 2.9146 79.4738 17.826 80.7899 36.6297H82.0308C84.8886 36.6297 87.22 38.7357 87.22 41.3307V59.8336C87.22 62.4285 84.9074 64.5345 82.0308 64.5345H74.4726V36.6485C73.2129 20.985 60.6723 8.64975 45.4431 8.64975C30.214 8.64975 17.6734 20.985 16.4137 36.6485V64.5345H8.85549C5.99766 64.5345 3.66628 62.4285 3.66628 59.8336V41.3495C3.66628 38.7546 5.99766 36.6485 8.85549 36.6485H10.0964C11.3749 17.8072 26.7169 2.9146 45.4243 2.9146ZM45.4243 0.846191C26.4537 0.846191 10.4348 15.5131 8.17863 34.5989C4.47474 34.8998 1.56052 37.8144 1.56052 41.3307V59.8148C1.56052 63.5379 4.81317 66.5841 8.81788 66.5841H18.4442V36.7237C19.6663 22.132 31.4925 10.6994 45.4055 10.6994C59.3186 10.6994 71.2012 22.1696 72.3857 36.799V36.8366V64.5157V66.5841H82.012C86.0167 66.5841 89.2694 63.5567 89.2694 59.8148V41.3119C89.2694 39.6007 88.5925 37.9648 87.3328 36.7049C86.1107 35.4827 84.4374 34.7305 82.6513 34.5801C80.3951 15.5131 64.395 0.846191 45.4243 0.846191Z"
            fill="white"
          />
          <path
            d="M68.0613 65.5498C66.576 65.5498 65.3915 64.4216 65.3915 63.0301V38.1152C65.3915 36.7237 66.5948 35.5955 68.0613 35.5955H72.6112V65.5498H68.0613Z"
            fill="url(#paint2_linear_509_528)"
          />
          <path
            d="M71.5772 36.6297V64.5157H68.0613C67.1588 64.5157 66.4256 63.8575 66.4256 63.0302V38.1152C66.4256 37.2878 67.1588 36.6297 68.0613 36.6297H71.5772ZM73.6453 34.5613H68.0613C66.012 34.5613 64.3574 36.1596 64.3574 38.1152V63.0302C64.3574 64.9858 66.0308 66.5841 68.0613 66.5841H73.6453V34.5613Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_509_528"
              x1="21.8473"
              y1="35.5955"
              x2="21.8473"
              y2="65.5498"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="var(--COR_MOD_PRI)" />
              <stop offset="1" stop-color="var(--COR_MOD_TER)" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_509_528"
              x1="45.415"
              y1="1.88037"
              x2="45.415"
              y2="65.5499"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="var(--COR_MOD_PRI)" />
              <stop offset="1" stop-color="var(--COR_MOD_TER)" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_509_528"
              x1="69.0014"
              y1="35.5955"
              x2="69.0014"
              y2="65.5498"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="var(--COR_MOD_PRI)" />
              <stop offset="1" stop-color="var(--COR_MOD_TER)" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="conteudo">
        <div class="botoes">
          <div class="podcast-container">
            <audio controls="true" style="" controlsList="nodownload">
              <source src={arquivoMP3} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>

            <div class="button-wrapper">
              <button on:click={abrir} class="btn-label">
                <h3>Transcrição</h3>
                <i class="fa-solid fa-angles-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-container {ativo ? 'active' : ''}">
  <div class="background {ativo ? 'active' : ''}" on:click={() => (ativo = false)} />
  <div class="dialog">
    <div class="title">
      <h3>
        <slot name="titulo-transcricao">PODCAST TRANSCRITO</slot>
      </h3>
      <div class="botao-fechar" on:click={() => (ativo = false)}>
        <IoIosClose />
      </div>
    </div>
    <div class="text">
      <slot name="texto" />
      {#if false}
        <slot />
      {/if}
      {@html content}
    </div>
  </div>
</div>

<style>
  p.comando {
    padding: 0;
    margin: 0 0 1.5rem 0;
  }
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    right: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(223, 223, 223);
    border-radius: 15px;
    padding: 5px 0;
  }
  .wrapper {
    position: relative;
    width: 100%;
    min-width: 250px;
  }
  .title {
    display: flex;
    /* justify-content: flex-end; */
  }
  .title :global(h3) {
    margin: 0;
    font-family: var(--FONT_ARCHI);
    color: #fff;
    font-weight: 600;
    background: linear-gradient(90deg, var(--COR_MOD_TER_POD_1) 0.09%, var(--COR_MOD_TER) 99.91%);
    padding: 6px 15px 6px 80px;
    font-size: 24px;
    border-radius: 12.7px 8.7px 8.7px 0px;
  }
  .caixa {
    position: relative;
    display: flex;
  }
  .conteudo {
    width: calc(100%);
    /* width: calc(100% - 120px); */
    display: flex;
    justify-content: right;
    /* background: var(--COR_VERMELHO); */
  }
  audio::-webkit-media-controls-panel {
    /* background-color: #747c30; */
    background: var(--COR_MOD_TER);
    /* border: 2px solid var(--COR_MOD_PRI_20); */
  }

  .botoes {
    background: #f1f3f4;
    margin: 0;
    padding: 0px 150px;
    color: #662482;
    font-family: var(--FONT_INTER);
    font-weight: 400;
    font-size: 17px;
    width: 100%;
    line-height: 27px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 0 15px 15px 15px;
    border: 2px solid var(--COR_MOD_TER_POD_2);
  }

  .ilustra svg {
    position: absolute;
    top: -50px;
    left: -22px;
    z-index: 98;
    width: 99px;
  }
  .podcast-container {
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .button-wrapper {
    width: 100%;
    max-width: 300px;
  }

  .btn-label {
    margin-top: 25px;
    padding: 8px 24px;
    border-style: solid;
    border-width: 0px;
    background: #747c30;
    background: var(--COR_MOD_TER_POD_2);
    color: var(--COR_MOD_TER_POD_1);
    font-size: 18px;
    text-decoration: none;
    border-radius: 15px;
    border: 2px solid var(--COR_MOD_TER_POD_1);
    font-family: var(--FONT_INTER);
    font-weight: 300;
    opacity: 0.9;
    width: 100%;
    max-width: 300px;
  }

  .btn-label:hover {
    opacity: 1;
  }

  .btn-label:hover i {
    padding: 0 10px;
    transition: 200ms padding ease-in-out;
  }

  .btn-label i {
    transition: 200ms padding ease-in-out;
  }

  .btn-label {
    display: grid;
    grid-template-columns: 90% 10%;
    align-items: center;
    width: 100%;
  }

  .btn-label h3 {
    margin: 0;
    padding: 5px;
    color: var(--COR_MOD_TER_POD_1);
    font-family: var(--FONT_INTER);
    font-weight: 500;
    font-size: 20px;
  }

  .background,
  .dialog-container {
    visibility: hidden;
    position: fixed;
    left: 0;
    height: 100vh;
    width: 100vw;
    max-width: 100%;
    opacity: 0;
  }
  .background {
    top: 0;
    background: rgba(0, 0, 0, 0.308);
  }
  .dialog-container {
    top: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 400;
    transition: all 300ms ease;
  }
  .background.active,
  .dialog-container.active {
    visibility: visible;
    opacity: 1;
  }
  .dialog-container.active {
    transform: translateY(-50%);
    top: 50%;
  }
  .dialog {
    max-width: 36em;
    max-height: 90vh;
    padding: 30px 20px 0 20px;
    position: relative;
    z-index: 500;

    background: #898d68;
    background: var(--COR_MOD_TER_POD_2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    border: 2px solid var(--COR_MOD_TER);
    color: #222;
  }

  .dialog .title {
    display: flex;
    /* padding: 5px 20px; */
    position: relative;
    justify-content: center;
  }
  .dialog .title h3 {
    /* background: var(--COR_MOD_PRI); */
    background: transparent;
    padding: 0px 5px;
    color: var(--COR_MOD_TER_POD_1);
  }
  .dialog .text {
    padding: 20px;
    font-family: var(--FONT_INTER);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(90vh - 100px);
    font-size: 17px;
    color: var(--COR_MOD_TER_POD_1);
    font-weight: 400;
  }
  .dialog :global(p) {
    font-family: var(--FONT_INTER);
    color: #fff;
  }
  .botao-fechar {
    width: 50px;
    cursor: pointer;
    color: var(--COR_MOD_TER_POD_1);
    position: absolute;
    right: -10px;
    top: -3px;
    opacity: 0.8;
  }
  .botao-fechar:hover {
    opacity: 1;
  }
  .dialog-container :global(ul li),
  .dialog-container :global(ol li) {
    font-weight: 400;
    padding-left: 15px;
    color: var(--COR_MOD_TER_POD_1);
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .dialog-container :global(::marker) {
    content: '\f054';
    color: var(--COR_MOD_TER_POD_1);
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
  }

  @media (max-width: 800px) {
    audio {
      max-width: 270px;
    }
    .botoes {
      width: 100%;
      padding: 50px 15px 30px 15px;
    }
    .ilustra svg {
      width: 72px;
      top: -53px;
      left: -13px;
    }
    .dialog {
      width: 92vw;
    }
    .dialog .text {
      padding: 20px 10px 0px 10px;
    }
    .title h3 {
      padding: 6px 15px 6px 70px;
    }
    .button-wrapper {
      max-width: 270px;
    }
    .botao-fechar {
      width: 40px;
      right: -20px;
      top: -20px;
    }
    .dialog .title {
      margin-bottom: 10px;
    }
  }
</style>
